import React from "react";
import LandingRegisterForm from "./LandingRegisterForm";
import styles from "./LandingConversion.module.css";
import pageStyles from "../WelcomePage.module.css";

import appMockup from "../../../../assets/downloadPage/app-home-mockup.webp";
import appStoreBadge from "../../../../assets/downloadPage/appStoreBadge.webp";
import googlePlayBadge from "../../../../assets/downloadPage/googlePlayBadge.webp";
import ComingSoonBadge from "../../../../components/ui/ComingSoonBadge";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../../../config/appStores";

const LandingConversion = ({ section, reveal, sectionReveal }) => {
  const titleParts = (section.mobile_column_title || "").trim();
  const accent =
    titleParts.toLowerCase().includes("bolsillo") ? "en tu bolsillo" : null;
  const mainTitle = accent
    ? titleParts.replace(/en tu bolsillo/i, "").trim() || "Lleva la suerte"
    : titleParts || "Lleva la suerte";

  // Los enlaces a las tiendas salen SOLO de src/config/appStores.js: el contenido administrable
  // traía un enlace de relleno (…/id0000000000) que abría una página inexistente del App Store.
  const appStoreUrl = APP_STORE_URL;
  // Google Play sale de la configuración (no del contenido administrable): mientras la app no
  // esté publicada en Play se muestra el badge atenuado con "Próximamente".
  const playStoreUrl = PLAY_STORE_URL;

  return (
    <section
      ref={reveal?.ref}
      className={`${styles.section} ${sectionReveal(reveal)}`}
      id="descarga"
    >
      <div className={styles.inner}>
        <div className={styles.split}>
          <div className={`${styles.formPanel} ${pageStyles.revealFromLeft}`}>
            <LandingRegisterForm
              formTitle={section.form_title}
              formSubtitle={section.form_subtitle}
              ctaLabel={section.cta_label}
              loginLinkText={section.login_link_text}
              contactTitle={section.contact_title}
            />
          </div>

          <div className={`${styles.appPanel} ${pageStyles.revealFromRight}`}>
            <div className={styles.appGlow} aria-hidden />
            <div className={styles.appLayout}>
              <header className={styles.appHeader}>
                <h2 className={styles.appTitle}>
                  {mainTitle}
                  {accent && (
                    <span className={styles.appTitleAccent}>{accent}</span>
                  )}
                </h2>
              </header>

              <div className={styles.showcase}>
                {/* App Store publicada; Google Play en "Próximamente" mientras no haya enlace. */}
                <div className={styles.appSoon}>
                  <p className={styles.appSoonText}>
                    Descarga la app de Gold Loterías y juega desde tu celular.
                  </p>
                  <div className={styles.storeRow}>
                    {appStoreUrl && (
                      <a
                        href={appStoreUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.storeLink}
                        aria-label="Descargar Gold Loterías en el App Store"
                      >
                        <img src={appStoreBadge} alt="Descárgala en el App Store" className={styles.storeBadge} />
                      </a>
                    )}
                    {playStoreUrl ? (
                      <a
                        href={playStoreUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.storeLink}
                        aria-label="Descargar Gold Loterías en Google Play"
                      >
                        <img src={googlePlayBadge} alt="Disponible en Google Play" className={styles.storeBadge} />
                      </a>
                    ) : (
                      <div className={styles.storeSoon} aria-label="Google Play: próximamente">
                        <img src={googlePlayBadge} alt="" aria-hidden="true"
                             className={`${styles.storeBadge} ${styles.storeBadgeOff}`} />
                        <ComingSoonBadge size="sm" className={styles.storeSoonBadge} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={styles.phoneStage}>
                <img
                  src={appMockup}
                  alt="Vista previa de la app Gold Loterías"
                  className={styles.mockupImage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingConversion;
